import { render, staticRenderFns } from "./invoice_statement_temp1.vue?vue&type=template&id=49a4054b"
import script from "./invoice_statement_temp1.vue?vue&type=script&lang=js"
export * from "./invoice_statement_temp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports